import {Table} from "antd";
import className from "classnames/bind";
import {UrlLink, StatusTag, fmt} from "./TechShared";
import style from "../style/Technical.module.scss";

const cn = className.bind(style);

/**
 * Liên kết hỏng: link nội bộ trỏ tới trang 4xx/5xx (mở rộng xem trang nguồn chứa link),
 * link ngoài hỏng (Tầng B HEAD-check), và lỗi server 5xx.
 */
function TechBrokenLinks({broken}) {

	const {internal = [], external = [], server = [], external_note} = broken || {};

	const internalColumns = [
		{title: 'URL đích (hỏng)', dataIndex: 'url', ellipsis: true, render: (url) => <UrlLink url={url} />},
		{title: 'Trạng thái', dataIndex: 'status', width: 110, align: 'center', render: (s) => <StatusTag status={s} />},
		{title: 'Số trang trỏ tới', dataIndex: 'sources', width: 140, align: 'right', render: (v) => fmt(v)},
	];

	const externalColumns = [
		{title: 'URL ngoài', dataIndex: 'url', ellipsis: true, render: (url, r) => <UrlLink url={url} text={url || r.message} />},
		{title: 'Trạng thái', dataIndex: 'status', width: 130, align: 'center', render: (s) => (s ? <StatusTag status={s} /> : <span className={cn('muted')}>Không kết nối</span>)},
	];

	const serverColumns = [
		{title: 'Trang', dataIndex: 'url', ellipsis: true, render: (url) => <UrlLink url={url} />},
		{title: 'Trạng thái', dataIndex: 'status', width: 110, align: 'center', render: (s) => <StatusTag status={s} />},
	];

	return (
		<div className={cn('tab')}>
			<h4 className={cn('sectionTitle')}>Link nội bộ hỏng ({internal.length})</h4>
			<Table
				size="small"
				rowKey={(r) => r.url}
				columns={internalColumns}
				dataSource={internal}
				pagination={{pageSize: 10, hideOnSinglePage: true}}
				expandable={{
					rowExpandable: (r) => (r.source_pages || []).length > 0,
					expandedRowRender: (r) => (
						<div className={cn('sourceList')}>
							<div className={cn('muted')}>Được trỏ tới từ các trang:</div>
							{(r.source_pages || []).map((sp, i) => (
								<div key={i} className={cn('sourceItem')}>
									<UrlLink url={sp.url} />
									{sp.anchor && <span className={cn('anchor')}>“{sp.anchor}”</span>}
								</div>
							))}
						</div>
					),
				}}
			/>

			<h4 className={cn('sectionTitle')}>Link ngoài hỏng ({external.length})</h4>
			{external_note && (
				<p className={cn('muted')}>
					Chỉ kiểm tra {fmt(external_note.checked)}/{fmt(external_note.total)} link ngoài phổ biến nhất (giới hạn để tránh quá tải khi crawl).
				</p>
			)}
			<Table size="small" rowKey={(r, i) => r.url || i} columns={externalColumns} dataSource={external}
				pagination={{pageSize: 10, hideOnSinglePage: true}} />

			<h4 className={cn('sectionTitle')}>Lỗi server 5xx ({server.length})</h4>
			<Table size="small" rowKey={(r) => r.url} columns={serverColumns} dataSource={server}
				pagination={{pageSize: 10, hideOnSinglePage: true}} />
		</div>
	);
}

export default TechBrokenLinks;
